var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMenuArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.60488 15.9433C6.28903 16.3012 6.28903 16.8382 6.60488 17.196C6.98166 17.6229 7.64733 17.6229 8.02411 17.196L13.2075 11.3235C13.8749 10.5674 13.8749 9.43263 13.2075 8.6765L8.02412 2.80396C7.64733 2.37708 6.98166 2.37708 6.60488 2.80396C6.28904 3.16179 6.28904 3.69881 6.60488 4.05665L10.6826 8.6765C11.35 9.43263 11.35 10.5674 10.6826 11.3235L6.60488 15.9433Z",
    fill: "white",
    fillOpacity: 0.22
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.98061 15.9433C1.66477 16.3012 1.66477 16.8382 1.98061 17.196C2.3574 17.6229 3.02306 17.6229 3.39985 17.196L8.58327 11.3235C9.25067 10.5674 9.25067 9.43263 8.58327 8.6765L3.39985 2.80396C3.02307 2.37708 2.3574 2.37708 1.98061 2.80396C1.66477 3.16179 1.66477 3.69881 1.98061 4.05665L6.05835 8.6765C6.72575 9.43263 6.72575 10.5674 6.05835 11.3235L1.98061 15.9433Z",
    fill: "white",
    fillOpacity: 0.08
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2291 15.9433C10.9133 16.3012 10.9133 16.8382 11.2291 17.196C11.6059 17.6229 12.2716 17.6229 12.6484 17.196L17.8318 11.3235C18.4992 10.5674 18.4992 9.43263 17.8318 8.6765L12.6484 2.80396C12.2716 2.37708 11.6059 2.37708 11.2291 2.80396C10.9133 3.16179 10.9133 3.69881 11.2291 4.05665L15.3069 8.6765C15.9743 9.43263 15.9743 10.5674 15.3069 11.3235L11.2291 15.9433Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuArrow);
export default __webpack_public_path__ + "static/media/icon_menu_arrow.0e625381104faf14b9517215e7008250.svg";
export { ForwardRef as ReactComponent };